'use strict';
// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
exports.f = Object.getOwnPropertySymbols;



// WEBPACK FOOTER //
// ./~/core-js/internals/object-get-own-property-symbols.js